<template>
  <div>
    <b-row class='mb-3'>
      <b-col cols="12">
        <div class="border-top pt-3">
          <b-row>
            <b-col cols="2">
              <label>Kolejność</label>
              <d-input
                class="mb-2 mr-sm-2 mb-sm-0"
                :value="form.doc.newsOrder"
                @input='(e) => actions.handleSimplePropChanged("newsOrder", e)'
                placeholder="Nr"
              />
            </b-col>
            <b-col v-for='(locale, i) in locales' :key='i' class='mb-3'>
              <label>News {{ locale.toUpperCase() }}</label>
              <d-input
                class="mb-2 mr-sm-2 mb-sm-0"
                :value="form.doc.newsOptionName ? form.doc.newsOptionName[locale] : ''"
                @input='(e) => actions.handleSimplePropWithLocaleChanged("newsOptionName", e, locale)'
                placeholder="Nazwa opcji"
              />
            </b-col>
          </b-row>
          <b-row class='mb-3'>
            <b-col cols="1">
              <label>Ukryj</label><br/>
              <b-form-checkbox
                v-model='form.doc.newsHide'
                @input='(e) => actions.handleSimplePropChanged("newsHide", e)'
                class='float-left mt-2'
              />
            </b-col>
            <b-col cols="2">
              <label>Tło główne</label><br/>
              <b-form-checkbox
                v-model='form.doc.newsMainBackground'
                @input='(e) => actions.handleSimplePropChanged("newsMainBackground", e)'
                class='float-left mt-2'
              />
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>

    <b-row class='mb-3'>
      <b-col cols="12">
        <div class="border-top pt-3">
          <b-row>
            <b-col cols="2">
              <label>Kolejność</label>
              <d-input
                class="mb-2 mr-sm-2 mb-sm-0"
                :value="form.doc.artistsOrder"
                @input='(e) => actions.handleSimplePropChanged("artistsOrder", e)'
                placeholder="Nr"
              />
            </b-col>
            <b-col v-for='(locale, i) in locales' :key='i' class='mb-3'>
              <label>Artyści {{ locale.toUpperCase() }}</label>
              <d-input
                class="mb-2 mr-sm-2 mb-sm-0"
                :value="form.doc.artistsOptionName ? form.doc.artistsOptionName[locale] : ''"
                @input='(e) => actions.handleSimplePropWithLocaleChanged("artistsOptionName", e, locale)'
                placeholder="Nazwa opcji"
              />
            </b-col>
          </b-row>
          <b-row class='mb-3'>
            <b-col cols="1">
              <label>Ukryj</label><br/>
              <b-form-checkbox
                v-model='form.doc.artistsHide'
                @input='(e) => actions.handleSimplePropChanged("artistsHide", e)'
                class='float-left mt-2'
              />
            </b-col>
            <b-col cols="2">
              <label>Tło główne</label><br/>
              <b-form-checkbox
                v-model='form.doc.artistsMainBackground'
                @input='(e) => actions.handleSimplePropChanged("artistsMainBackground", e)'
                class='float-left mt-2'
              />
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>

    <b-row class='mb-3'>
      <b-col cols="12">
        <div class="border-top pt-3">
          <b-row>
            <b-col cols="2">
              <label>Kolejność</label>
              <d-input
                class="mb-2 mr-sm-2 mb-sm-0"
                :value="form.doc.delegatesOrder"
                @input='(e) => actions.handleSimplePropChanged("delegatesOrder", e)'
                placeholder="Nr"
              />
            </b-col>
            <b-col v-for='(locale, i) in locales' :key='i' class='mb-3'>
              <label>Delegaci {{ locale.toUpperCase() }}</label>
              <d-input
                class="mb-2 mr-sm-2 mb-sm-0"
                :value="form.doc.delegatesOptionName ? form.doc.delegatesOptionName[locale] : ''"
                @input='(e) => actions.handleSimplePropWithLocaleChanged("delegatesOptionName", e, locale)'
                placeholder="Nazwa opcji"
              />
            </b-col>
          </b-row>
          <b-row class='mb-3'>
            <b-col cols="1">
              <label>Ukryj</label><br/>
              <b-form-checkbox
                v-model='form.doc.delegatesHide'
                @input='(e) => actions.handleSimplePropChanged("delegatesHide", e)'
                class='float-left mt-2'
              />
            </b-col>
            <b-col cols="2">
              <label>Tło główne</label><br/>
              <b-form-checkbox
                v-model='form.doc.delegatesMainBackground'
                @input='(e) => actions.handleSimplePropChanged("delegatesMainBackground", e)'
                class='float-left mt-2'
              />
            </b-col>
          </b-row>
        </div>
      </b-col>      
    </b-row>

    <b-row class='mb-3'>
      <b-col cols="12">
        <div class="border-top pt-3">
          <b-row>
            <b-col cols="2">
              <label>Kolejność</label>
              <d-input
                class="mb-2 mr-sm-2 mb-sm-0"
                :value="form.doc.programOrder"
                @input='(e) => actions.handleSimplePropChanged("programOrder", e)'
                placeholder="Nr"
              />
            </b-col>
            <b-col v-for='(locale, i) in locales' :key='i' class='mb-3'>
              <label>Program {{ locale.toUpperCase() }}</label>
              <d-input
                class="mb-2 mr-sm-2 mb-sm-0"
                :value="form.doc.programOptionName ? form.doc.programOptionName[locale] : ''"
                @input='(e) => actions.handleSimplePropWithLocaleChanged("programOptionName", e, locale)'
                placeholder="Nazwa opcji"
              />
            </b-col>
          </b-row>
          <b-row class='mb-3'>
            <b-col cols="1">
              <label>Ukryj</label><br/>
              <b-form-checkbox
                v-model='form.doc.programHide'
                @input='(e) => actions.handleSimplePropChanged("programHide", e)'
                class='float-left mt-2'
              />
            </b-col>
            <b-col cols="2">
              <label>Tło główne</label><br/>
              <b-form-checkbox
                v-model='form.doc.programMainBackground'
                @input='(e) => actions.handleSimplePropChanged("programMainBackground", e)'
                class='float-left mt-2'
              />
            </b-col>
          </b-row>
        </div>
      </b-col>      
    </b-row>

    <b-row class='mb-3'>
      <b-col cols="12">
        <div class="border-top pt-3">
          <b-row>
            <b-col cols="2">
              <label>Kolejność</label>
              <d-input
                class="mb-2 mr-sm-2 mb-sm-0"
                :value="form.doc.notificationsOrder"
                @input='(e) => actions.handleSimplePropChanged("notificationsOrder", e)'
                placeholder="Nr"
              />
            </b-col>
            <b-col v-for='(locale, i) in locales' :key='i' class='mb-3'>
              <label>Powiadomienia {{ locale.toUpperCase() }}</label>
              <d-input
                class="mb-2 mr-sm-2 mb-sm-0"
                :value="form.doc.notificationsOptionName ? form.doc.notificationsOptionName[locale] : ''"
                @input='(e) => actions.handleSimplePropWithLocaleChanged("notificationsOptionName", e, locale)'
                placeholder="Nazwa opcji"
              />
            </b-col>
          </b-row>
          <b-row class='mb-3'>
            <b-col cols="1">
              <label>Ukryj</label><br/>
              <b-form-checkbox
                v-model='form.doc.notificationsHide'
                @input='(e) => actions.handleSimplePropChanged("notificationsHide", e)'
                class='float-left mt-2'
              />
            </b-col>
            <b-col cols="2">
              <label>Tło główne</label><br/>
              <b-form-checkbox
                v-model='form.doc.notificationsMainBackground'
                @input='(e) => actions.handleSimplePropChanged("notificationsMainBackground", e)'
                class='float-left mt-2'
              />
            </b-col>
          </b-row>
        </div>
      </b-col>          
    </b-row>

    <b-row class='mb-3'>
      <b-col cols="12">
        <div class="border-top pt-3">
          <b-row>
            <b-col cols="2">
              <label>Kolejność</label>
              <d-input
                class="mb-2 mr-sm-2 mb-sm-0"
                :value="form.doc.mapOrder"
                @input='(e) => actions.handleSimplePropChanged("mapOrder", e)'
                placeholder="Nr"
              />
            </b-col>
            <b-col v-for='(locale, i) in locales' :key='i' class='mb-3'>
              <label>Mapa {{ locale.toUpperCase() }}</label>
              <d-input
                class="mb-2 mr-sm-2 mb-sm-0"
                :value="form.doc.mapOptionName ? form.doc.mapOptionName[locale] : ''"
                @input='(e) => actions.handleSimplePropWithLocaleChanged("mapOptionName", e, locale)'
                placeholder="Nazwa opcji"
              />
            </b-col>
          </b-row>
          <b-row class='mb-3'>
            <b-col cols="1">
              <label>Ukryj</label><br/>
              <b-form-checkbox
                v-model='form.doc.mapHide'
                @input='(e) => actions.handleSimplePropChanged("mapHide", e)'
                class='float-left mt-2'
              />
            </b-col>            
            <b-col cols="2">
              <label>Tło główne</label><br/>
              <b-form-checkbox
                v-model='form.doc.mapMainBackground'
                @input='(e) => actions.handleSimplePropChanged("mapMainBackground", e)'
                class='float-left mt-2'
              />
            </b-col>
          </b-row>
        </div>
      </b-col>         
    </b-row>

    <b-row class='mb-3'>
      <b-col cols="12">
        <div class="border-top pt-3">
          <b-row>
            <b-col cols="2">
              <label>Kolejność</label>
              <d-input
                class="mb-2 mr-sm-2 mb-sm-0"
                :value="form.doc.ticketsOrder"
                @input='(e) => actions.handleSimplePropChanged("ticketsOrder", e)'
                placeholder="Nr"
              />
            </b-col>
            <b-col v-for='(locale, i) in locales' :key='i' class='mb-3'>
              <label>Bilety {{ locale.toUpperCase() }}</label>
              <d-input
                class="mb-2 mr-sm-2 mb-sm-0"
                :value="form.doc.ticketsOptionName ? form.doc.ticketsOptionName[locale] : ''"
                @input='(e) => actions.handleSimplePropWithLocaleChanged("ticketsOptionName", e, locale)'
                placeholder="Nazwa opcji"
              />
            </b-col>
          </b-row>
          <b-row class='mb-3'>
            <b-col cols="1">
              <label>Ukryj</label><br/>
              <b-form-checkbox
                v-model='form.doc.ticketsHide'
                @input='(e) => actions.handleSimplePropChanged("ticketsHide", e)'
                class='float-left mt-2'
              />
            </b-col>            
            <b-col cols="2">
              <label>Tło główne</label><br/>
              <b-form-checkbox
                v-model='form.doc.ticketsMainBackground'
                @input='(e) => actions.handleSimplePropChanged("ticketsMainBackground", e)'
                class='float-left mt-2'
              />
            </b-col>
          </b-row>
        </div>
      </b-col>         
    </b-row>

    <b-row class='mb-3'>
      <b-col cols="12">
        <div class="border-top pt-3">
          <b-row>
            <b-col cols="2">
              <label>Kolejność</label>
              <d-input
                class="mb-2 mr-sm-2 mb-sm-0"
                :value="form.doc.votingOrder"
                @input='(e) => actions.handleSimplePropChanged("votingOrder", e)'
                placeholder="Nr"
              />
            </b-col>
            <b-col v-for='(locale, i) in locales' :key='i' class='mb-3'>
              <label>Głosowanie {{ locale.toUpperCase() }}</label>
              <d-input
                class="mb-2 mr-sm-2 mb-sm-0"
                :value="form.doc.votingOptionName ? form.doc.votingOptionName[locale] : ''"
                @input='(e) => actions.handleSimplePropWithLocaleChanged("votingOptionName", e, locale)'
                placeholder="Nazwa opcji"
              />
            </b-col>
          </b-row>
          <b-row class='mb-3'>
            <b-col cols="1">
              <label>Ukryj</label><br/>
              <b-form-checkbox
                v-model='form.doc.votingHide'
                @input='(e) => actions.handleSimplePropChanged("votingHide", e)'
                class='float-left mt-2'
              />
            </b-col>            
            <b-col cols="2">
              <label>Tło główne</label><br/>
              <b-form-checkbox
                v-model='form.doc.votingMainBackground'
                @input='(e) => actions.handleSimplePropChanged("votingMainBackground", e)'
                class='float-left mt-2'
              />
            </b-col>
          </b-row>
        </div>
      </b-col>         
    </b-row>

    <b-row class='mb-3'>
      <b-col cols="12">
        <div class="border-top pt-3">
          <b-row>
            <b-col cols="2">
              <label>Kolejność</label>
              <d-input
                class="mb-2 mr-sm-2 mb-sm-0"
                :value="form.doc.myLineUp"
                @input='(e) => actions.handleSimplePropChanged("myLineUpOrder", e)'
                placeholder="Nr"
              />
            </b-col>
            <b-col v-for='(locale, i) in locales' :key='i' class='mb-3'>
              <label>Mój line-up {{ locale.toUpperCase() }}</label>
              <d-input
                class="mb-2 mr-sm-2 mb-sm-0"
                :value="form.doc.myLineUpOptionName ? form.doc.myLineUpOptionName[locale] : ''"
                @input='(e) => actions.handleSimplePropWithLocaleChanged("myLineUpOptionName", e, locale)'
                placeholder="Nazwa opcji"
              />
            </b-col>
          </b-row>
          <b-row class='mb-3'>
            <b-col cols="1">
              <label>Ukryj</label><br/>
              <b-form-checkbox
                v-model='form.doc.myLineUpHide'
                @input='(e) => actions.handleSimplePropChanged("myLineUpHide", e)'
                class='float-left mt-2'
              />
            </b-col>            
            <b-col cols="2">
              <label>Tło główne</label><br/>
              <b-form-checkbox
                v-model='form.doc.myLineUpMainBackground'
                @input='(e) => actions.handleSimplePropChanged("myLineUpMainBackground", e)'
                class='float-left mt-2'
              />
            </b-col>
          </b-row>
        </div>
      </b-col>         
    </b-row>

    <b-row class='mb-3'>
      <b-col v-for='(locale, i) in locales' :key='i' class='mb-3'>
        <label>Delegaci opis {{ locale.toUpperCase() }}</label>
          <b-form-textarea
            rows='3'
            max-rows='6'
            placeholder='Wpisz tekst...'
            :value="form.doc.delegatesDescription ? form.doc.delegatesDescription[locale] : ''"
            @input='(e) => actions.handleSimplePropWithLocaleChanged("delegatesDescription", e, locale)'
          />
      </b-col>
    </b-row>

    <hr />

    <b-row class='mb-3'>
      <b-col cols="12">
        <label>Menu boczne - linki</label>
    </b-col>
    </b-row>

    <b-row class='mb-3'>
      <b-col cols="3">
        <label>Rozmiar</label>
        <d-input
          class="mb-2 mr-sm-2 mb-sm-0"
          :value="form.doc.sideMenuLinks.size"
          @input='(e) => actions.handleNestedPropChanged("sideMenuLinks.size", e)'
          placeholder="Rozmiar..."
          type="number"
        />
      </b-col>
      <b-col cols="3">
        <label>Odstęp w poziomie</label>
        <d-input
          class="mb-2 mr-sm-2 mb-sm-0"
          :value="form.doc.sideMenuLinks.space"
          @input='(e) => actions.handleNestedPropChanged("sideMenuLinks.space", e)'
          placeholder="Odstęp..."
          type="number"
        />
      </b-col>
      <b-col cols="3">
        <label>Top margin</label>
        <d-input
          class="mb-2 mr-sm-2 mb-sm-0"
          :value="form.doc.sideMenuLinks.marginTop"
          @input='(e) => actions.handleNestedPropChanged("sideMenuLinks.marginTop", e)'
          placeholder="Top margin..."
          type="number"
        />
      </b-col>
      <b-col cols="3">
        <label>Bottom margin</label>
        <d-input
          class="mb-2 mr-sm-2 mb-sm-0"
          :value="form.doc.sideMenuLinks.marginBottom"
          @input='(e) => actions.handleNestedPropChanged("sideMenuLinks.marginBottom", e)'
          placeholder="Bottom margin..."
          type="number"
        />
      </b-col>
    </b-row>

    <b-row class='mb-3'>
      <b-col cols="4" style="border-right: 1px solid silver;">
        <label>Side Menu Facebook link</label>
        <d-input
          class="mb-2 mr-sm-2 mb-sm-0"
          :value="form.doc.sideMenuLinks.facebook.link"
          @input='(e) => actions.handleNestedPropChanged("sideMenuLinks.facebook.link", e)'
          placeholder="Podaj link..."
        />

        <b-row class='mt-2'>
          <b-col>
            <b-form-checkbox
              v-model='form.doc.sideMenuLinks.facebook.visible'
              @input='(e) => actions.handleSimplePropChanged("sideMenuLinks.facebook.visible", e)'
              class='float-left mt-2'
            >
              <label>Pokaż w aplikacji</label>
            </b-form-checkbox>
          </b-col>
        </b-row>
        
        <b-row class='mt-2'>
          <b-col>
            <label>Otwórz w</label>
            <b-form-select
              v-model='form.doc.sideMenuLinks.facebook.openWith'
              :options='wrapper_options'
              @input='(e) => actions.handleSimplePropChanged("sideMenuLinks.facebook.openWith", e)'
            />
          </b-col>
        </b-row>
      </b-col>

      <b-col cols="4" style="border-right: 1px solid silver;">
        <label>Side Menu Instagram link</label>
        <d-input
          class="mb-2 mr-sm-2 mb-sm-0"
          :value="form.doc.sideMenuLinks.instagram.link"
          @input='(e) => actions.handleNestedPropChanged("sideMenuLinks.instagram.link", e)'
          placeholder="Podaj link..."
        />

        <b-row class='mt-2'>
          <b-col>
            <b-form-checkbox
              v-model='form.doc.sideMenuLinks.instagram.visible'
              @input='(e) => actions.handleSimplePropChanged("sideMenuLinks.instagram.visible", e)'
              class='float-left mt-2'
            >
              <label>Pokaż w aplikacji</label>
            </b-form-checkbox>
          </b-col>
        </b-row>

        <b-row class='mt-2'>
          <b-col>
            <label>Otwórz w</label>
            <b-form-select
              v-model='form.doc.sideMenuLinks.instagram.openWith'
              :options='wrapper_options'
              @input='(e) => actions.handleSimplePropChanged("sideMenuLinks.instagram.openWith", e)'
            />
          </b-col>
        </b-row>        
      </b-col>

      <b-col cols="4">
        <label>Side Menu Spotify link</label>
        <d-input
          class="mb-2 mr-sm-2 mb-sm-0"
          :value="form.doc.sideMenuLinks.spotify.link"
          @input='(e) => actions.handleNestedPropChanged("sideMenuLinks.spotify.link", e)'
          placeholder="Podaj link..."
        />

        <b-row class='mt-2'>
          <b-col>
            <b-form-checkbox
              v-model='form.doc.sideMenuLinks.spotify.visible'
              @input='(e) => actions.handleSimplePropChanged("sideMenuLinks.spotify.visible", e)'
              class='float-left mt-2'
            >
              <label>Pokaż w aplikacji</label>
            </b-form-checkbox>
          </b-col>
        </b-row>

        <b-row class='mt-2'>
          <b-col>
            <label>Otwórz w</label>
            <b-form-select
              v-model='form.doc.sideMenuLinks.spotify.openWith'
              :options='wrapper_options'
              @input='(e) => actions.handleSimplePropChanged("sideMenuLinks.spotify.openWith", e)'
            />
          </b-col>
        </b-row>        
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import { LOCALES, SOCIAL_MEDIA_WRAPPER_OPTIONS } from '@/const'
  import { handleSimplePropChanged, handleSimplePropWithLocaleChanged, handleNestedPropChanged } from '@/store/utils'
  
  export default {
    data() {
      return {
        locales: LOCALES,
        wrapper_options: SOCIAL_MEDIA_WRAPPER_OPTIONS,
        actions: {
          handleSimplePropChanged,
          handleSimplePropWithLocaleChanged,
          handleNestedPropChanged,
        },
      }
    },
    computed: {
      form() {
        return this.$store.state.fanzones.form
      }
    },
  }
</script>